__turbopack_context__.v({
  "actions": "ELoW1a_actions",
  "header": "ELoW1a_header",
  "title": "ELoW1a_title",
});
